<template>
  <section :id="sectionData.id" class="section-custom" v-html="sectionData.html"></section>
</template>

<script>
import externalAssetsMixin from '../mixins/externalAssets';

export default {
  name: 'SectionCustom',

  mixins: [externalAssetsMixin],

  props: {
    sectionData: {
      type: Object,
      required: true,
    },
  },
};
</script>
